import React from 'react';
import { cn } from '../../../lib/utils';
import { CheckTick } from '../../../components/icons';

interface BizRowProps {
  selected: boolean;
  onClick: () => void;
  label: string;
  desc?: string;
}

export function BizRow({ selected, onClick, label, desc }: BizRowProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full text-left bg-white rounded-lg px-4 py-3.5 border-2 transition-colors flex items-center justify-between gap-3 mb-2',
        selected ? 'border-ink' : 'border-stroke hover:border-helper'
      )}
    >
      <div className="min-w-0">
        <div className="text-[14px] font-medium text-ink">{label}</div>
        {desc && <div className="text-[12px] text-[#334155] mt-0.5">{desc}</div>}
      </div>
      <span className={cn(
        'w-[22px] h-[22px] rounded-full flex items-center justify-center shrink-0',
        selected ? 'bg-brand text-white' : 'border-2 border-[#CBD5E1]'
      )}>
        {selected && <CheckTick className="w-3.5 h-3.5" />}
      </span>
    </button>
  );
}
